import { ActionItem, labelStyle, inputStyle } from './types';
import { DEPT_DB_MAP } from '../../constants';

interface EscalateModalProps {
  selected: ActionItem;
  escalateReason: string;
  escalateFinding: string;
  acting: boolean;
  onSetEscalateReason: (v: string) => void;
  onSetEscalateFinding: (v: string) => void;
  onSubmit: () => void;
  onClose: () => void;
}

export default function EscalateModal({
  selected, escalateReason, escalateFinding, acting,
  onSetEscalateReason, onSetEscalateFinding, onSubmit, onClose,
}: EscalateModalProps) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--bg-elevated)', borderRadius: 12, padding: 24, width: 400, border: '1px solid var(--bg-border)' }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 16 }}>
          Escalate to {(() => { const n = parseInt((selected.current_level || 'L2').replace('L','')); return `L${Math.min((isNaN(n) ? 2 : n) + 1, 7)}`; })()}
        </h3>
        <p style={{ fontSize: 12, color: 'var(--text-dim)', marginBottom: 12 }}>
          Escalate within {(DEPT_DB_MAP[selected.current_department] || selected.current_department)} to a higher authority level.
        </p>
        <div style={{ marginBottom: 10 }}>
          <label style={labelStyle}>Reason (required)</label>
          <textarea value={escalateReason} onChange={e => onSetEscalateReason(e.target.value)} placeholder="Why does this need escalation?" style={{ ...inputStyle, minHeight: 60, resize: 'vertical' }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={labelStyle}>Finding (optional)</label>
          <textarea value={escalateFinding} onChange={e => onSetEscalateFinding(e.target.value)} placeholder="What did you find?" style={{ ...inputStyle, minHeight: 50, resize: 'vertical' }} />
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onClose}
            style={{ flex: 1, padding: 10, background: 'transparent', border: '1px solid var(--bg-border)', borderRadius: 6, color: 'var(--text-dim)', cursor: 'pointer', fontSize: 12 }}>
            Cancel
          </button>
          <button onClick={onSubmit} disabled={!escalateReason.trim() || acting}
            style={{ flex: 1, padding: 10, background: escalateReason.trim() ? '#f5f3ff' : 'rgba(0,0,0,0.03)', border: '1px solid #ddd6fe', borderRadius: 6, color: escalateReason.trim() ? 'var(--navy-800)' : 'var(--text-dim)', cursor: escalateReason.trim() ? 'pointer' : 'not-allowed', fontSize: 12, fontWeight: 700 }}>
            Escalate
          </button>
        </div>
      </div>
    </div>
  );
}
